import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20flowing%20patterns%20in%20amber%20and%20terracotta%20tones%2C%20minimalist%20modern%20design%2C%20soft%20gradient%20background%2C%20smooth%20curves%20suggesting%20stability%20and%20flow%2C%20warm%20inviting%20atmosphere%2C%20professional%20clean%20aesthetic%2C%20no%20text&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt="久久久久持久稳定体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-background-950/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          选择久久久久，选择持久稳定
        </h2>
        <p className="text-sm md:text-base text-background-300 mb-8 max-w-xl mx-auto leading-relaxed">
          久久久久以品质保障、长效服务、稳定性能和耐久方案四大核心优势，
          为您打造经久不衰的持久稳定体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解久久久久
          </Link>
          <Link
            to="/category/quality"
            className="px-8 py-3 border border-background-300 text-background-100 font-medium text-sm rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览解决方案
          </Link>
        </div>
      </div>
    </section>
  );
}